const _warnedIds = new Set();

function getRfidEnabledRelations(namespaces = [], { throwOnInvalid = true } = {}) {
    const results = namespaces.flatMap(namespace =>
        (namespace.relations || []).flatMap(relation => {
            if (relation.supports_rfid_tags !== true) return [];
            const id = `${namespace.title}:${relation.title}`;
            const title = relation.rfid_processing_behavior_title;
            if (typeof title !== 'string' || !title.trim()) {
                if (throwOnInvalid) {
                    throw new Error(`Behavior title is required for RFID-enabled relation ${id}`);
                }
                if (!_warnedIds.has(id)) {
                    _warnedIds.add(id);
                    // eslint-disable-next-line no-console
                    console.warn(`[rfidEnabledRelations] Skipping misconfigured relation ${id}: missing behavior title`);
                }
                return [];
            }
            return [{ _id: id, title: title.trim() }];
        })
    );
    return results.sort((a, b) => a.title.localeCompare(b.title));
}

module.exports = { getRfidEnabledRelations };
